/**
 * Platform detection utility
 * Detects the user's platform (iOS or Android) based on user agent
 */
export const detectPlatform = (): 'ios' | 'android' => {
  if (typeof window === 'undefined') return 'ios' // SSR fallback

  const userAgent =
    navigator.userAgent ||
    navigator.vendor ||
    (window as Window & typeof globalThis & { opera?: string }).opera ||
    ''

  const isIOS =
    /iPad|iPhone|iPod/.test(userAgent) &&
    !(window as Window & typeof globalThis & { MSStream?: unknown }).MSStream

  return isIOS ? 'ios' : 'android'
}

/**
 * Device type detection utility
 * Returns detailed device information for responsive behavior
 */
export const getDeviceType = () => {
  if (typeof window === 'undefined') {
    return {
      isMobile: false,
      isTablet: false,
      isDesktop: true,
      isTouch: false,
    }
  }

  const userAgent = navigator.userAgent.toLowerCase()
  const standalone = (navigator as Navigator & { standalone?: boolean })
    .standalone
  const isTouch =
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    ((navigator as Navigator & { msMaxTouchPoints?: number })
      .msMaxTouchPoints ?? 0) > 0

  // Device type detection - iPad classification fix
  const isTablet =
    /ipad/.test(userAgent) ||
    (/android/.test(userAgent) && !/mobile/.test(userAgent)) ||
    (window.innerWidth >= 768 && window.innerWidth <= 1024 && isTouch)

  const isMobile =
    (/android|webos|iphone|ipod|blackberry|iemobile|opera mini/.test(
      userAgent,
    ) ||
      (window.innerWidth <= 768 && isTouch) ||
      Boolean(standalone)) &&
    !isTablet

  const isDesktop = !isMobile && !isTablet

  return {
    isMobile,
    isTablet,
    isDesktop,
    isTouch,
  }
}
